import { render } from "./SvgTires.vue?vue&type=template&id=45e07876&ts=true"
import script from "./SvgTires.vue?vue&type=script&lang=ts"
export * from "./SvgTires.vue?vue&type=script&lang=ts"

import "./SvgTires.vue?vue&type=style&index=0&id=45e07876&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__